<template>
  <div style="width: 100%" ref="dom"></div>
</template>

<script>
import echarts from "echarts";
import { on, off } from "@/libs/tools";
import tdTheme from "_c/charts/theme.json";
echarts.registerTheme("tdTheme", tdTheme);
export default {
  name: "growthRate",
  props: {
    value: Object,
    text: String
  },
  data() {
    return {
      dom: null,
      title: this.$t("extract") + this.$t("growthRate"),
      option: {
        title: {
          text: this.$t("extract") + this.$t("growthRate"),
          x: "center"
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999"
            }
          },
          formatter:
            "{b0}<br/>{a0}: {c0}<br />{a1}: {c1}<br />{a2}: {c2}%<br />"
        },
        legend: {
          data: [
            this.$t("lastMonth"),
            this.$t("thisMonth"),
            this.$t("growthRate")
          ],
          bottom: 0
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisPointer: {
              type: "shadow"
            }
          }
        ],
        yAxis: [
          {
            type: "value",
            name:
              this.$t("thisMonth") +
              this.$t("data") +
              "/" +
              this.$t("lastMonth") +
              this.$t("data"),
            // min: 0,
            // max: 10000,
            // interval: 1000,
            axisLabel: {
              formatter: "{value}"
            }
          },
          {
            type: "value",
            name: this.$t("growthRate"),
            boundaryGap: ["0%", "100%"],
            // min: 0,
            // max: 100,
            axisLabel: {
              show: true,
              interval: "auto",
              formatter: "{value}%"
            },
            show: true
          }
        ],
        series: [
          {
            name: this.$t("lastMonth"),
            type: "bar",
            data: [],
            label: {
              show: true,
              position: "top"
            }
          },
          {
            name: this.$t("thisMonth"),
            type: "bar",
            data: [],
            label: {
              show: true,
              position: "top"
            }
          },
          {
            name: this.$t("growthRate"),
            type: "line",
            yAxisIndex: 1,
            data: [],
            // markLine: {
            //   data: [
            //     {
            //       type: "average",
            //       name: "Avg"
            //     }
            //   ]
            // },
            label: {
              show: true,
              position: "top",
              formatter: "{c}%"
            }
          }
        ]
      }
    };
  },
  watch: {
    value: {
      handler(val) {
        this.setOpt();
      },
      deep: true
    }
  },
  methods: {
    resize() {
      this.dom.resize();
    },
    setOpt() {
      this.option.xAxis[0].data = this.value.time;
      this.option.series[0].data = this.value.lastMonth;
      this.option.series[1].data = this.value.currentMonth;
      this.option.series[2].data = this.value.growthRate;
      this.$nextTick(() => {
        this.dom = echarts.init(this.$refs.dom);
        this.dom.setOption(this.option, true);
        on(window, "resize", this.resize);
      });
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.dom = echarts.init(this.$refs.dom, "tdTheme");
      this.dom.setOption(this.option, true);
    });
    if (this.value && this.value.rows) {
      this.setOpt();
    }
  },
  beforeDestroy() {
    off(window, "resize", this.resize);
  }
};
</script>
